export enum TipoErro {
  SUCESSO = 0,
  ERRO = 1,
  BUSINESS_VIOLATION = 2,
}
